import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PickupPageComponent } from './pickup-page/pickup-page.component';
import { PickupTableComponent } from './pickup-table/pickup-table.component';
import { PickupTableFilterComponent } from './pickup-table-filter/pickup-table-filter.component';
import { MaterialModule } from '../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { BookPickupComponent } from './book-pickup/book-pickup.component';
import { CancelPickupComponent } from './cancel-pickup/cancel-pickup.component';


@NgModule({
    exports: [
        PickupPageComponent,
        PickupTableComponent,
        PickupTableFilterComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        SharedModule,
        PickupPageComponent,
        PickupTableComponent,
        PickupTableFilterComponent,
        BookPickupComponent,
        CancelPickupComponent
    ]
})
export class PickupModule {
}
